import LoadingSpinner from '@carvana/loading-spinner';
import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 2rem;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 0.5rem;
`;

export const ContentHeader = styled.p`
  color: #183558;
  font-size: 24px;
  font-weight: 450;
  line-height: 28px;
`;

export const ContentSubtext = styled.p`
  color: #6d7184;
  font-size: 16px;
  font-weight: 390;
  line-height: 22px;
`;

export const Spinner = styled(LoadingSpinner).attrs({ isLarge: true })`
  height: auto;
`;
